import { __assign, __rest } from "tslib";
import * as React from 'react';
import { View, StyleSheet } from 'react-native';
import color from 'color';
import TouchableRipple from './TouchableRipple';
import Icon from './Icon';
import CrossFadeIcon from './CrossFadeIcon';
/**
 *
 * ## Usage
 * ```js
 * import * as React from 'react';
 * import { IconButton, Colors } from 'pnmac-universal-components';
 *
 * const MyComponent = () => (
 *   <IconButton
 *     icon="camera"
 *     color={Colors.red500}
 *     size={20}
 *     onPress={() => console.log('Pressed')}
 *   />
 * );
 *
 * export default MyComponent;
 * ```
 */
var IconButton = function (_a) {
  var icon = _a.icon,
    customColor = _a.color,
    _b = _a.size,
    size = _b === void 0 ? 24 : _b,
    accessibilityLabel = _a.accessibilityLabel,
    disabled = _a.disabled,
    onPress = _a.onPress,
    _c = _a.animated,
    animated = _c === void 0 ? false : _c,
    theme = _a.theme,
    style = _a.style,
    button = _a.button,
    rest = __rest(_a, ["icon", "color", "size", "accessibilityLabel", "disabled", "onPress", "animated", "theme", "style", "button"]);
  var iconColor = typeof customColor !== 'undefined' ? customColor : "#003087";
  var rippleColor = color(iconColor).alpha(0.32).rgb().string();
  var IconComponent = animated ? CrossFadeIcon : Icon;
  var buttonSize = size * 1.5;
  return /*#__PURE__*/React.createElement(TouchableRipple, __assign({
    borderless: true,
    centered: true,
    onPress: onPress,
    rippleColor: rippleColor,
    style: [styles.container, {
      width: buttonSize,
      height: buttonSize,
      borderRadius: buttonSize / 2
    }, disabled && styles.disabled, style],
    accessibilityLabel: accessibilityLabel,
    accessibilityTraits: disabled ? ['button', 'disabled'] : 'button',
    accessibilityComponentType: "button",
    accessibilityRole: "button",
    accessibilityStates: disabled ? ['disabled'] : [],
    disabled: disabled,
    hitSlop:
    // @ts-ignore - this should be fixed in react-theme-providersince withTheme() is not forwarding static property types
    TouchableRipple.supported ? {
      top: 10,
      left: 10,
      bottom: 10,
      right: 10
    } : {
      top: 6,
      left: 6,
      bottom: 6,
      right: 6
    }
  }, rest), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(IconComponent, __assign({
    color: iconColor,
    source: icon,
    size: size
  }, rest))));
};
var styles = StyleSheet.create({
  // @ts-ignore - this should be fixed in react-theme-providersince withTheme() is not forwarding static property types
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    margin: 6
  },
  disabled: {
    opacity: 0.32
  }
});
export default IconButton;